























































































import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop, Ref } from "vue-property-decorator";

import { Address } from "@/models/address";
import { required, postalCodeRules } from "@/utils/validation";

@Component({})
export class AddressInputGroup extends Vue {
  @Prop({ default: false })
  optional!: boolean;

  private addressLineErrorMessages: string[] = [];
  @Prop({ default: "" })
  label!: string;

  @Prop({ default: false })
  disabled!: boolean;

  set addressLineErrorBucket(value) {
    console.log(value);
  }

  get addressLineErrorBucket() {
    return [];
  }

  private get formConfig() {
    return {
      postal_code: {
        label: this.$t('general.address.postalCode'),
        rules: [required, ...postalCodeRules],
        prefix: "H-"
      },
      state: {
        label: this.$t('general.address.state'),
        rules: [required],
        items: Object.entries(States).map(([value, text]) => ({ text, value }))
      },
      city: {
        label: this.$t('general.address.city'),
        rules: [required]
      },
      address_line_1: {
        label: this.$t('general.address.line1'),
        rules: [required]
      },
      address_line_2: {}
    };
  }

  private formData: Address = {
    postal_code: "",
    country: "",
    state: "",
    city: "",
    address_line_1: "",
    address_line_2: ""
  };

  private internalValue: null | Address = null;

  @Prop({ required: true })
  @Model("change")
  value!: Address | null;

  get hasAddress() {
    return this.value !== null || !this.optional;
  }

  set hasAddress(value) {
    this.$emit("change", value ? this.formData : null);
  }

  mounted() {
    Object.entries(this.value || {}).forEach(([key, value]) => {
      this.formData[key as keyof Address] = value;
    });
  }
}

const States = Object.freeze({
  "HU-BA": "Baranya",
  "HU-BK": "Bács-Kiskun",
  "HU-BE": "Békés",
  "HU-BZ": "Borsod-Abaúj-Zemplén",
  "HU-BU": "Budapest",
  "HU-CS": "Csongrád",
  "HU-FE": "Fejér",
  "HU-GS": "Győr-Moson-Sopron",
  "HU-HB": "Hajdú-Bihar",
  "HU-HE": "Heves",
  "HU-JN": "Jász-Nagykun-Szolnok",
  "HU-KE": "Komárom-Esztergom",
  "HU-NO": "Nógrád",
  "HU-PE": "Pest",
  "HU-SO": "Somogy",
  "HU-SZ": "Szabolcs-Szatmár-Bereg",
  "HU-TO": "Tolna",
  "HU-VA": "Vas",
  "HU-VE": "Veszprém",
  "HU-ZA": "Zala"
});

export default AddressInputGroup;
